// src/components/DealReport.jsx
import * as XLSX from "xlsx";
import api from "../api";
import React, { useEffect, useState } from "react";

const DealReport = () => {
  const [deals, setDeals] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  useEffect(() => {
    const fetchDeals = async () => {
      try {
        const res = await api.get("/my-deals");
        setDeals(res.data);
      } catch (err) {
        console.error("Error fetching deals:", err);
      }
    };
    fetchDeals();
  }, []);

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const exportToExcel = () => {
    if (!Array.isArray(deals) || deals.length === 0) {
      alert("⚠️ No deals to export!");
      return;
    }

    let filteredDeals = deals;

    if (fromDate && toDate) {
      const from = new Date(fromDate);
      const to = new Date(toDate);
      filteredDeals = deals.filter((deal) => {
        const dealDate = new Date(deal.date);
        return dealDate >= from && dealDate <= to;
      });
    }

    if (filteredDeals.length === 0) {
      alert("⚠️ No deals found in the selected date range!");
      return;
    }

    const dataForExcel = filteredDeals.map((deal, index) => {
      const bales = parseInt(deal.bales) || 0;
      const dalali = parseInt(deal.dalali) || 0;
      const amount = bales * dalali;

      return {
        "S.No": index + 1,
        "Sauda Date": formatDate(deal.date),
        Buyer: deal.buyer,
        Seller: deal.seller,
        Station: deal.station,
        Bales: bales,
        Dalali: dalali,
        Amount: amount,
        "Candy Rate": deal.candy_rate,
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(dataForExcel);

    // Auto column widths
    const colWidths = Object.keys(dataForExcel[0]).map((key) => ({
      wch: Math.max(
        key.length,
        ...dataForExcel.map((row) =>
          row[key] ? row[key].toString().length : 0
        )
      ),
    }));
    worksheet["!cols"] = colWidths;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "My Deals");

    // filename with date range
    const filename =
      fromDate && toDate
        ? `MyDealsReport_${fromDate}_to_${toDate}.xlsx`
        : "MyDealsReport.xlsx";

    XLSX.writeFile(workbook, filename);
  };

  return (
  <div className="container">
    <div className="row g-2 align-items-end">

      <div className="col-12 col-md-3">
        <label className="form-label">From:</label>
        <input
          type="date"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
          className="form-control"
        />
      </div>

      <div className="col-12 col-md-3">
        <label className="form-label">To:</label>
        <input
          type="date"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
          className="form-control"
        />
      </div>

      <div className="col-12 col-md-3 mt-3 mt-md-0">
        <button className="btn btn-success w-100" onClick={exportToExcel}>
          ⬇️ Download Excel
        </button>
      </div>

    </div>
  </div>
);

};

export default DealReport;
